import React from "react";
import { motion } from "framer-motion";
import { MANIFESTO } from "../data/products";
import Reveal from "./Reveal";

export const Manifesto = () => {
  return (
    <section id="manifesto" data-testid="manifesto-section" className="relative py-24 md:py-36 bg-[#050505] overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <Reveal>
          <h2 className="font-display uppercase leading-[0.85] text-[#F5F5F5] text-[13vw] md:text-[8.5vw] lg:text-[7.5rem] max-w-5xl">
            No Excuses.<br />
            No Shortcuts.<br />
            <span className="text-[#E6DFD4]">Only Results.</span>
          </h2>
        </Reveal>

        <Reveal delay={0.15}>
          <p className="mt-10 max-w-2xl text-lg md:text-xl text-[#A3A3A3] leading-relaxed">
            Peptides are not a magic pill. They are a tool for people already doing the work —
            the ones training hard, eating clean and refusing to settle. If that's you, SANDFORM
            is the edge that turns discipline into transformation.
          </p>
        </Reveal>

        <div className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-px bg-[#1c1c1c] border border-[#1c1c1c]">
          {MANIFESTO.map((c, i) => (
            <motion.div
              key={c.num}
              data-testid={`manifesto-chapter-${c.num}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
              className="bg-[#080808] p-8 md:p-10 hover:bg-[#0d0d0b] transition-colors duration-500"
            >
              <div className="font-display text-7xl md:text-8xl leading-none text-[#E6DFD4]/20 mb-6">
                {c.num}
              </div>
              <h3 className="font-display text-3xl uppercase leading-none text-[#F5F5F5] mb-4">
                {c.title}
              </h3>
              <p className="text-sm text-[#A3A3A3] leading-relaxed">{c.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Manifesto;
